import * as React from 'react';

export const ToastError = (message) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: message}} />
  );
};
